import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-custom-chip',
  templateUrl: './custom-chip.component.html',
  styleUrls: ['./custom-chip.component.scss']
})
export class CustomChipComponent {
  @Input() label: string;
  @Input() removable: boolean = false;
  @Output() remove = new EventEmitter<void>();

  onRemoveClick() {
    this.remove.emit();
  }
}